export default __webpack_public_path__ + "static/media/icons8-handshake-heart-100.bcb929b6.svg";